import React, { FC } from 'react';
import styles from './sectionTitle.module.scss';
import Breadcrumbs from "../../../componsnts/common/breadcrumbs/breadcrumbs";

interface SectionTitleProps {
  title: string;
  subTitle: string;
  backgroundColor?: string; 
  titleColor?: string;   
  subTitleColor?: string; 
  breadcrumbs?:boolean;
} 

const SectionTitle: FC<SectionTitleProps> = ({ title, subTitle, backgroundColor , titleColor = '#fff', subTitleColor, breadcrumbs = true }) => {
  return (
    <div  className={styles['sectionTitle_container']} style={{ backgroundColor }}>
      {breadcrumbs === true && (
      <Breadcrumbs></Breadcrumbs>
      )}
        <div data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-once="false" className="section_box">
            <div className="subTitle" style={{ color: subTitleColor }}>
              {subTitle}
              <div className="title" style={{ color: titleColor }}>
                {title}
              </div>
            </div>
        </div>
    </div>
  );
};

export default SectionTitle;